<template>
    <div  class="bg">
      <v-card>
        <div class="cont">
          <div class="c1"><img src="@/assets/img/tip.png" class="img1"></div>
          <h2>消息通知</h2>
          <div class="c2"><a href="/" class="home">首页</a></div>
          <div class="c3"> {{errorCode?errorCode:message}}</div>
        </div>
      </v-card>
    </div>
</template>
<script>
  import { mdiHome } from '@mdi/js';
    export default {
        data() {
            return {
              mdiHome:mdiHome,
                message:'对不起服务出现了错误！',
                errorCode:null,
                errCode:500
            };
        },
        created() {
            if (window.location.href.indexOf("errMsg") > -1) {
                let message = decodeURIComponent(window.location.href.match(/errMsg=(\S*)/)[1])
                this.message = message
            }else if(window.location.href.indexOf("errCode") > -1) {
                 this.errCode = decodeURIComponent(window.location.href.match(/errCode=(\S*)/)[1])
                if( this.errCode == 501){
                    this.errorCode = "访问权限限制"
                }else if( this.errCode == 502){
                    this.errorCode = "访问策略限制"
                }

            }else {

            }

            console.log( this.errorCode )
        },
        methods:{

            refreshLogin(){
                window.location.href="/"
            },
        }
    };
</script>


<style lang='scss' scoped>
  .bg{
    width: 100%;
    background: url(../../assets/img/01.jpg) no-repeat center top #DAD9D7;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    overflow: hidden;
  }

  .cont {
    margin: 0 auto;
    width: 500px;
    line-height: 20px;
  }
  .c1 {
    height: 360px;
    text-align: center;
  }
  .cont h2 {
    text-align: center;
    color: #555;
    font-size: 18px;
    font-weight: normal;
    height: 35px;
  }
  .c2 {
    height: 35px;
    text-align: center;
  }
  .c3 {
    height: 180px;
    text-align: center;
    color: #999;
    font-size: 12px;
  }
  .c1 .img1 {
    margin-top: 180px;
  }
  .notice-wrap {
    padding-top: 30px;
  }
  /*.notice {*/
  /*  margin: 0 auto;*/
  /*  max-width: 682px;*/
  /*  max-height: 633px;*/

  /*  background: url(../../assets/img/update-bg.png) no-repeat;*/
  /*}*/

  .notice h1 {
    padding-top: 225px;
    font-size: 36px;
    color: #333;
    text-align: center;
  }
  .notice>p {
    margin: 0 62px;
    font-size: 18px;
    color: #666;
    text-indent: 36px;
    line-height: 40px;
    min-height: 150px;
  }
  .notice-foot {
    margin-top: 24px;
  }

</style>
